import React from 'react';
import { motion } from 'framer-motion';
import { User } from 'lucide-react';
import { colors, radius } from '../designSystem';

interface WelcomeCardProps {
  isAuthenticated: boolean;
  customerName?: string;
  onLogin: () => void;
  onLogout: () => void;
}

export const WelcomeCard: React.FC<WelcomeCardProps> = ({
  isAuthenticated,
  customerName,
  onLogin,
  onLogout,
}) => {
  if (isAuthenticated) {
    return (
      <div className="px-6 py-4 border-b" style={{ borderColor: colors.divider }}>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div
              className="w-10 h-10 flex items-center justify-center"
              style={{
                borderRadius: '50%',
                backgroundColor: colors.secondary,
              }}
            >
              <User className="h-5 w-5" style={{ color: colors.textSecondary }} />
            </div>
            <div>
              <p className="text-base font-semibold" style={{ color: colors.textPrimary }}>
                {customerName}
              </p>
              <p className="text-sm" style={{ color: colors.textSecondary }}>
                מחובר
              </p>
            </div>
          </div>
          <button
            onClick={onLogout}
            className="text-sm px-4 py-2"
            style={{
              color: colors.accent,
              fontWeight: 500,
            }}
          >
            התנתק
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="px-6 py-6 border-b" style={{ borderColor: colors.divider }}>
      <button
        onClick={onLogin}
        data-login-trigger
        className="w-full py-3 text-center font-semibold"
        style={{
          backgroundColor: colors.accent,
          color: colors.white,
          borderRadius: radius.lg,
        }}
      >
        התחבר
      </button>
    </div>
  );
};
